/**
 * Hala Fashion Product Card Slider & Wishlist Component
 * Inspired by Paper Design
 */

if (!customElements.get('hala-card-slider')) {
  class HalaCardSlider extends HTMLElement {
    constructor() {
      super();
      this.track = null;
      this.slides = [];
      this.prevBtn = null;
      this.nextBtn = null;
      this.dots = [];
      this.currentIndex = 0;
    }

    connectedCallback() {
      this.track = this.querySelector('.hala-card__track');
      if (!this.track) return;

      this.slides = Array.from(this.querySelectorAll('.hala-card__slide'));
      this.prevBtn = this.querySelector('.hala-card__nav--prev');
      this.nextBtn = this.querySelector('.hala-card__nav--next');
      this.dots = Array.from(this.querySelectorAll('.hala-card__dot'));

      if (this.slides.length <= 1) {
        if (this.prevBtn) this.prevBtn.classList.add('is-hidden');
        if (this.nextBtn) this.nextBtn.classList.add('is-hidden');
        return;
      }

      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.slidePrev();
        });
      }

      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.slideNext();
        });
      }

      // Scroll listener with debounce
      this.track.addEventListener('scroll', () => {
        this.updateNavState();
      }, { passive: true });

      this.updateNavState();
    }

    slidePrev() {
      const slideWidth = this.track.clientWidth;
      this.track.scrollBy({ left: -slideWidth, behavior: 'smooth' });
    }

    slideNext() {
      const slideWidth = this.track.clientWidth;
      this.track.scrollBy({ left: slideWidth, behavior: 'smooth' });
    }

    updateNavState() {
      const slideWidth = this.track.clientWidth || 1;
      const scrollLeft = this.track.scrollLeft;
      const index = Math.round(scrollLeft / slideWidth);

      this.currentIndex = Math.max(0, Math.min(this.slides.length - 1, index));

      // Update dots
      if (this.dots.length > 0) {
        this.dots.forEach((dot, i) => {
          dot.classList.toggle('is-active', i === this.currentIndex);
        });
      }

      // Update arrow states
      if (this.prevBtn) {
        if (scrollLeft <= 5) {
          this.prevBtn.setAttribute('disabled', 'disabled');
          this.prevBtn.classList.add('is-hidden');
        } else {
          this.prevBtn.removeAttribute('disabled');
          this.prevBtn.classList.remove('is-hidden');
        }
      }

      if (this.nextBtn) {
        const maxScroll = this.track.scrollWidth - this.track.clientWidth;
        if (scrollLeft >= maxScroll - 5) {
          this.nextBtn.setAttribute('disabled', 'disabled');
          this.nextBtn.classList.add('is-hidden');
        } else {
          this.nextBtn.removeAttribute('disabled');
          this.nextBtn.classList.remove('is-hidden');
        }
      }
    }
  }

  customElements.define('hala-card-slider', HalaCardSlider);
}

// Global Wishlist Manager for Hala Fashion Cards
(function () {
  if (window.__halaWishlistInit) return;
  window.__halaWishlistInit = true;

  const STORAGE_KEY = 'halafashion_wishlist';
  const HEART_PATH =
    'M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z';

  function normalizeItem(item) {
    if (item && typeof item === 'object') {
      return { id: String(item.id || ''), handle: String(item.handle || '') };
    }
    return { id: String(item || ''), handle: '' };
  }

  function getWishlist() {
    try {
      const raw = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
      if (!Array.isArray(raw)) return [];
      return raw.map(normalizeItem).filter((item) => item.id);
    } catch (e) {
      return [];
    }
  }

  function setWishlist(items) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (e) {}
  }

  function updateHeaderCount(count) {
    document.querySelectorAll('[data-wishlist-count]').forEach((node) => {
      node.textContent = count > 99 ? '99+' : String(count);
      const bubble = node.closest('.wishlist-count-bubble');
      if (bubble) {
        if (count > 0) bubble.removeAttribute('hidden');
        else bubble.setAttribute('hidden', '');
      }
    });
  }

  function syncWishlistButtons() {
    const list = getWishlist();
    let changed = false;

    document.querySelectorAll('.hala-card__wishlist-btn').forEach((btn) => {
      const id = btn.dataset.productId;
      const handle = btn.dataset.productHandle;
      const entry = id ? list.find((item) => item.id === String(id)) : null;
      const active = !!entry;

      if (entry && handle && !entry.handle) {
        entry.handle = handle;
        changed = true;
      }

      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      const label = active ? btn.dataset.labelRemove : btn.dataset.labelAdd;
      if (label) btn.setAttribute('aria-label', label);
    });

    if (changed) setWishlist(list);
    updateHeaderCount(list.length);
  }

  function formatMoney(cents, format) {
    const placeholder = /\{\{\s*(\w+)\s*\}\}/;
    const amount = (Number(cents) / 100).toFixed(2);
    const amountNoDecimals = String(Math.round(Number(cents) / 100));
    const withThousands = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    const value = String(format || 'Rs. {{amount}}');
    const match = value.match(placeholder);
    const key = match ? match[1] : 'amount';
    const formatted =
      key === 'amount_no_decimals' || key === 'amount_no_decimals_with_comma_separator'
        ? amountNoDecimals
        : withThousands;
    return value.replace(placeholder, formatted);
  }

  function offerLabel(price, compare) {
    const selling = Number(price);
    const original = Number(compare);
    if (!original || original <= selling) return '';
    return Math.round(((original - selling) / original) * 100) + '% off';
  }

  function productImage(product) {
    const image = product && (product.featured_image || (product.images && product.images[0]));
    if (!image) return '';
    const src = typeof image === 'string' ? image : image.src;
    if (!src) return '';
    return src.indexOf('//') === 0 ? 'https:' + src : src;
  }

  function variantImage(variant) {
    const image = variant && variant.featured_image;
    if (!image) return '';
    const src = typeof image === 'string' ? image : image.src;
    if (!src) return '';
    return src.indexOf('//') === 0 ? 'https:' + src : src;
  }

  function colorOptionIndex(product) {
    const options = product.options || [];
    const index = options.findIndex((option) => {
      const name = String(typeof option === 'string' ? option : option.name || '').toLowerCase();
      return name === 'color' || name === 'colour';
    });
    return index;
  }

  function createWishlistCard(product, item, page) {
    const article = document.createElement('article');
    article.className = 'wishlist-page__item';

    const wrapper = document.createElement('div');
    wrapper.className = 'product-card-wrapper';
    const card = document.createElement('div');
    card.className = 'hala-card';

    const href = product.url || '/products/' + item.handle;
    const variants = product.variants || [];
    const selected = variants.find((entry) => entry.available) || variants[0];
    const moneyFormat = page.dataset.moneyFormat;

    const media = document.createElement('div');
    media.className = 'hala-card__media-container';
    const link = document.createElement('a');
    link.className = 'hala-card__media-link';
    link.href = href;
    link.setAttribute('aria-label', product.title || '');
    const img = document.createElement('img');
    img.className = 'hala-card__image';
    img.alt = product.title || '';
    const src = variantImage(selected) || productImage(product);
    if (src) img.src = src;
    link.appendChild(img);
    media.appendChild(link);

    const heartWrap = document.createElement('div');
    heartWrap.className = 'hala-card__wishlist';
    const heart = document.createElement('button');
    heart.type = 'button';
    heart.className = 'hala-card__wishlist-btn is-active';
    heart.dataset.productId = String(product.id || item.id);
    heart.dataset.productHandle = product.handle || item.handle;
    heart.dataset.labelAdd = page.dataset.addLabel || '';
    heart.dataset.labelRemove = page.dataset.removeLabel || '';
    heart.setAttribute('aria-pressed', 'true');
    heart.setAttribute('aria-label', page.dataset.removeLabel || 'Remove from wishlist');
    heart.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="' + HEART_PATH + '"></path></svg>';
    heartWrap.appendChild(heart);
    media.appendChild(heartWrap);
    card.appendChild(media);

    const info = document.createElement('div');
    info.className = 'hala-card__info';
    const content = document.createElement('div');
    content.className = 'hala-card__info-content';

    const title = document.createElement('h3');
    title.className = 'hala-card__title';
    const titleLink = document.createElement('a');
    titleLink.href = href;
    titleLink.textContent = product.title || item.handle;
    title.appendChild(titleLink);
    content.appendChild(title);

    const swatches = document.createElement('div');
    swatches.className = 'hala-card__swatches';
    const colorIndex = colorOptionIndex(product);
    if (colorIndex > -1) {
      const key = 'option' + (colorIndex + 1);
      const values = [];
      variants.forEach((variant) => {
        const value = variant[key];
        if (value && value !== 'Default Title' && values.indexOf(value) === -1) values.push(value);
      });
      values.slice(0, 5).forEach((value, index) => {
        const variant = variants.find((entry) => entry[key] === value);
        if (!variant) return;
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'hala-card__swatch' + (selected && selected[key] === value ? ' is-active' : '');
        button.dataset.variantId = String(variant.id);
        button.dataset.available = variant.available ? 'true' : 'false';
        button.dataset.price = formatMoney(variant.price, moneyFormat);
        button.dataset.priceCents = String(variant.price);
        if (variant.compare_at_price > variant.price) {
          button.dataset.compare = formatMoney(variant.compare_at_price, moneyFormat);
          button.dataset.compareCents = String(variant.compare_at_price);
        }
        const image = variantImage(variant);
        if (image) button.dataset.image = image;
        button.setAttribute('aria-label', value);
        button.setAttribute('aria-pressed', button.classList.contains('is-active') ? 'true' : 'false');
        if (image) {
          const thumb = document.createElement('img');
          thumb.src = image;
          thumb.alt = value;
          thumb.width = 35;
          thumb.height = 35;
          button.appendChild(thumb);
        }
        swatches.appendChild(button);
      });
      if (values.length > 5) {
        const more = document.createElement('a');
        more.className = 'hala-card__swatch-more';
        more.href = href;
        more.textContent = values.length - 5 + '+';
        swatches.appendChild(more);
      }
    }
    content.appendChild(swatches);

    const price = document.createElement('div');
    price.className = 'hala-card__price-wrap';
    price.dataset.offerSuffix = 'off';
    if (selected && selected.compare_at_price > selected.price) {
      const compare = document.createElement('s');
      compare.className = 'hala-card__price-compare';
      compare.textContent = formatMoney(selected.compare_at_price, moneyFormat);
      price.appendChild(compare);
    }
    const current = document.createElement('span');
    current.className = 'hala-card__price-current';
    current.textContent = formatMoney(selected ? selected.price : product.price, moneyFormat);
    price.appendChild(current);
    if (selected && selected.compare_at_price > selected.price) {
      const offer = document.createElement('span');
      offer.className = 'hala-card__offer';
      offer.textContent = offerLabel(selected.price, selected.compare_at_price);
      price.appendChild(offer);
      const badges = document.createElement('div');
      badges.className = 'hala-card__badges';
      const badge = document.createElement('span');
      badge.className = 'hala-card__badge hala-card__badge--sale';
      badge.textContent = offer.textContent;
      badges.appendChild(badge);
      media.appendChild(badges);
    }
    content.appendChild(price);

    const add = document.createElement('button');
    add.type = 'button';
    add.className = 'hala-card__atc wishlist-page__add';
    if (!selected || selected.available === false) {
      add.disabled = true;
      add.textContent = page.dataset.soldOut || 'Sold out';
    } else {
      add.dataset.variantId = String(selected.id);
      const label = document.createElement('span');
      label.textContent = page.dataset.addToCart || 'Add to cart';
      add.appendChild(label);
    }
    content.appendChild(add);

    info.appendChild(content);
    card.appendChild(info);
    wrapper.appendChild(card);
    article.appendChild(wrapper);
    return article;
  }

  function createUnavailableCard(item, page) {
    const article = document.createElement('article');
    article.className = 'wishlist-page__item wishlist-page__item--missing';
    const message = document.createElement('p');
    message.textContent = page.dataset.unavailable || 'This product is no longer available.';
    article.appendChild(message);
    const heart = document.createElement('button');
    heart.type = 'button';
    heart.className = 'hala-card__wishlist-btn is-active';
    heart.dataset.productId = item.id;
    heart.dataset.productHandle = item.handle || '';
    heart.dataset.labelRemove = page.dataset.removeLabel || '';
    heart.setAttribute('aria-label', page.dataset.removeLabel || 'Remove from wishlist');
    heart.textContent = page.dataset.removeLabel || 'Remove';
    article.appendChild(heart);
    return article;
  }

  let renderToken = 0;

  async function renderWishlistPage() {
    const page = document.querySelector('[data-wishlist-page]');
    if (!page) return;

    const token = ++renderToken;
    const list = getWishlist();
    const grid = page.querySelector('[data-wishlist-grid]');
    const empty = page.querySelector('[data-wishlist-empty]');
    const count = page.querySelector('[data-wishlist-page-count]');
    const template = list.length === 1 ? page.dataset.countOne : page.dataset.countOther;

    if (count) count.textContent = (template || '').replace('__COUNT__', String(list.length));
    if (empty) empty.hidden = list.length > 0;
    if (grid) grid.hidden = list.length === 0;
    if (!grid || !list.length) {
      if (grid) grid.replaceChildren();
      return;
    }

    const cards = await Promise.all(
      list.map(async (item) => {
        if (!item.handle) return createUnavailableCard(item, page);
        try {
          const response = await fetch('/products/' + encodeURIComponent(item.handle) + '?view=card');
          if (!response.ok) return createUnavailableCard(item, page);
          const html = await response.text();
          const component = new DOMParser().parseFromString(html, 'text/html').querySelector('product-component');
          if (!component) return createUnavailableCard(item, page);
          const article = document.createElement('article');
          article.className = 'wishlist-page__item';
          article.appendChild(component);
          return article;
        } catch (e) {
          return createUnavailableCard(item, page);
        }
      })
    );

    if (token !== renderToken || !grid.isConnected) return;
    grid.replaceChildren(...cards);
    syncWishlistButtons();
  }

  document.addEventListener('click', function (event) {
    const btn = event.target.closest('.hala-card__wishlist-btn');
    if (!btn || btn.disabled || !btn.dataset.productId) return;

    event.preventDefault();
    event.stopPropagation();

    const id = String(btn.dataset.productId);
    const handle = btn.dataset.productHandle || '';
    const currentList = getWishlist();
    const index = currentList.findIndex((item) => item.id === id);

    if (index > -1) {
      currentList.splice(index, 1);
    } else {
      currentList.push({ id: id, handle: handle });
    }

    setWishlist(currentList);
    syncWishlistButtons();
    document.dispatchEvent(
      new CustomEvent('halafashion:wishlist:update', {
        detail: { wishlist: currentList, productId: id },
      })
    );
  });

  document.addEventListener('click', function (event) {
    const button = event.target.closest('.wishlist-page__add');
    if (!button || button.disabled || !button.dataset.variantId) return;

    event.preventDefault();
    button.disabled = true;
    button.classList.add('is-loading');

    const formData = new FormData();
    formData.append('id', button.dataset.variantId);
    formData.append('quantity', '1');

    const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    if (cart && typeof cart.getSectionsToRender === 'function') {
      formData.append(
        'sections',
        cart
          .getSectionsToRender()
          .map((section) => section.id)
          .join(',')
      );
      formData.append('sections_url', window.location.pathname);
    }

    const cartAddUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
    fetch(cartAddUrl, {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status) throw new Error(data.description || data.message || 'Error');
        if (cart && typeof cart.renderContents === 'function') {
          cart.renderContents(data);
        } else {
          window.location = (window.routes && window.routes.cart_url) || '/cart';
        }
      })
      .catch(() => {
        button.disabled = false;
      })
      .finally(() => {
        button.classList.remove('is-loading');
        if (!button.textContent || button.dataset.variantId) button.disabled = false;
      });
  });

  document.addEventListener('click', function (event) {
    const swatch = event.target.closest('.hala-card__swatch');
    if (!swatch) return;
    const card = swatch.closest('.hala-card');
    if (!card) return;
    event.preventDefault();

    card.querySelectorAll('.hala-card__swatch').forEach((el) => {
      const active = el === swatch;
      el.classList.toggle('is-active', active);
      el.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    const input = card.querySelector('.product-variant-id');
    if (input) input.value = swatch.dataset.variantId;

    const image = card.querySelector('.hala-card__image');
    if (image && swatch.dataset.image) {
      image.src = swatch.dataset.image;
      image.srcset = '';
    }

    const current = card.querySelector('.hala-card__price-current');
    const compare = card.querySelector('.hala-card__price-compare');
    if (current && swatch.dataset.price) current.textContent = swatch.dataset.price;
    if (compare) {
      compare.textContent = swatch.dataset.compare || '';
      compare.hidden = !swatch.dataset.compare;
    }
    const offerText = offerLabel(Number(swatch.dataset.priceCents), Number(swatch.dataset.compareCents));
    card.querySelectorAll('.hala-card__offer, .hala-card__badge--sale').forEach((node) => {
      node.textContent = offerText;
      node.hidden = !offerText;
    });

    const button = card.querySelector('.hala-card__atc');
    if (button) {
      if (swatch.dataset.variantId) button.dataset.variantId = swatch.dataset.variantId;
      const available = swatch.dataset.available === 'true';
      button.disabled = !available;
      const label = button.querySelector('span');
      if (label) label.textContent = available ? label.dataset.addLabel || label.textContent : label.dataset.soldLabel || label.textContent;
    }
  });

  function boot() {
    syncWishlistButtons();
    renderWishlistPage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('halafashion:wishlist:sync', syncWishlistButtons);
  document.addEventListener('halafashion:wishlist:update', renderWishlistPage);
})();
